import { ApprovalStatus } from 'ui-product-approvals/types';
import { CONTENT_PLATFORM_PROPERTY_NAME } from 'content-management-data-lib';
export const SELF_USER_IDENTIFIER = '__hs__ME';
export const PROPERTIES_WITH_SELF_USER_IDENTIFIER = [CONTENT_PLATFORM_PROPERTY_NAME.UPDATED_BY_USER_ID, CONTENT_PLATFORM_PROPERTY_NAME.CREATED_BY_USER_ID];
export const ApprovalStatusToFilterValue = {
  default: 'No Approval Requested',
  [ApprovalStatus.APPROVAL_PENDING]: 'pending',
  [ApprovalStatus.APPROVED]: 'approved',
  [ApprovalStatus.CANCELLED]: 'cancelled'
};
export const ApprovalValueToStatus = {
  'No Approval Requested': 'default',
  approved: ApprovalStatus.APPROVED,
  cancelled: ApprovalStatus.CANCELLED,
  pending: ApprovalStatus.APPROVAL_PENDING
};
export const FilterablePublishStates = {
  DRAFT: 'DRAFT',
  SCHEDULED: 'SCHEDULED',
  PUBLISHED: 'PUBLISHED',
  ARCHIVED: 'ARCHIVED'
};